<template>
    <v-container
        id="plot-grid-pagination"
        class="text-center mb-12"
    >
        <v-row justify="center">
            <v-container class="max-width">
                <v-pagination
                    v-model="currentPage"
                    :length="paginationLength"
                    :total-visible="totalVisible"
                />
            </v-container>
        </v-row>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'PlotGridPagination',
        props: {
            plotListLength: {
                type: Number,
                required: true
            },
            plotPerPage: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                currentPage: 1,
                totalVisible: 6
            }
        },
        computed: {
            paginationLength() {
                return Math.ceil(this.plotListLength / this.plotPerPage);
            }
        },
        mounted() {
            EventBus.$on('refreshPagination', page => this.currentPage = page);
        },
        watch: {
            currentPage() {
                this.$emit('update-page', this.currentPage);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/plotGrid/PlotGridPagination.vue